const ClosedTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#D3F8F2" />
      <path
        d="M20.1667 8.7816C18.941 8.07256 17.5179 7.66675 16.0001 7.66675C11.3977 7.66675 7.66675 11.3977 7.66675 16.0001C7.66675 20.6024 11.3977 24.3334 16.0001 24.3334C20.6024 24.3334 24.3334 20.6024 24.3334 16.0001C24.3334 15.4293 24.276 14.8719 24.1667 14.3334"
        stroke="#27CAB5"
        stroke-width="1.25"
        stroke-linecap="round"
      />
      <path
        d="M12.6667 16.4167C12.6667 16.4167 13.9167 16.4167 15.5834 19.3334C15.5834 19.3334 20.2157 11.6945 24.3334 10.1667"
        stroke="#27CAB5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ClosedTicketIcon;
